<template>
  <div v-loading="loading">
    <el-row>
      <el-row>
        <br />
        <el-col :span="24">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="股票选择">
              <el-select @focus="showSearchLogs" :popper-append-to-body="false" @change="getSearchLogs"
                v-model="stockCode" value-key="ts_code" filterable remote :remote-method="searchStock"
                default-first-option placeholder="请输入股票名称或股票代码">
                <el-option-group :label="searchLabel">
                  <el-option v-for="(item, index) in options" :key="index" :label="item.name" :value="item.symbol">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="quickGenPdf(stockCode, '普通搜索')">分析一下</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="selectDialogVisible = !selectDialogVisible">高级搜索&nbsp;&nbsp;<i class="iconfont"
                  style="font-size:5px!important;color:#aaa">
                  <template v-if="selectDialogVisible">
                    &#xee10;
                  </template>
                  <template v-else>
                    &#xe60f;
                  </template>
                </i></el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="24" v-if="selectDialogVisible">
          <el-form :model="selectForm" :inline="true">
            <el-row>
              <el-form-item label="行业">
                <el-select clearable :popper-append-to-body="false" @change="searchStockBySelect(1)"
                  v-model="selectForm.industry" filterable placeholder="请选择">
                  <el-option v-for="item in searchIndustryList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="概念">
                <el-select clearable :popper-append-to-body="false" @change="searchStockBySelect(1)"
                  v-model="selectForm.concept" filterable placeholder="请选择">
                  <el-option v-for="item in searchConceptList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="企业性质">
                <el-select clearable :popper-append-to-body="false" @change="searchStockBySelect(1)"
                  v-model="selectForm.companyType" filterable placeholder="请选择">
                  <el-option v-for="item in searchCompanyTypeList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="地区">
                <el-select clearable :popper-append-to-body="false" @change="searchStockBySelect(1)"
                  v-model="selectForm.location" filterable placeholder="请选择">
                  <el-option v-for="item in searchLocationList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-table stripe :data="searchStocks" style="width: 100%">
                <span slot="empty">
                  <div style="line-height:20px;">
                    <br />
                    <img src="../../assets/imgs/emptyTable.png" />
                    <div v-if="selectForm.industry ||
    selectForm.concept ||
    selectForm.companyType ||
    selectForm.location
    ">
                      暂无搜索记录！
                    </div>
                    <div v-else>请设置搜索条件！</div>
                    <br />
                  </div>
                </span>
                <el-table-column prop="short_name" label="股票">
                </el-table-column>
                <el-table-column prop="industry_name" label="行业">
                </el-table-column>
                <el-table-column prop="bk_name" label="概念"> </el-table-column>
                <el-table-column prop="location" label="地区">
                </el-table-column>
                <el-table-column prop="nature" label="企业性质">
                </el-table-column>
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button @click="quickGenPdf(scope.row.symbol, '高级搜索')" type="text" size="small">生成报告</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <br />
            </el-row>

            <el-row style="text-align:center" v-if="searchStocks && selectForm.total > 5">
              <el-pagination background :page-size="5" @current-change="searchStockBySelect"
                :currentPage="selectForm.page" layout="prev, pager, next" :total="selectForm.total">
              </el-pagination>
              <br />
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <el-row style="height:calc( 100vh - 370px );overflow-y:scroll">
        <br />
        <template>
          <el-row>
            <el-col :span="14">
              <h3>
                AI评分&nbsp;TOP10
                <el-popover placement="right" trigger="hover">
                  <span style="font-size:12px;color:#999">
                    AI评分：采用多维度、量化的评分体系全面衡量A股上市公司<br />
                    的经营状况、成长前景、技术趋势等，体现了股票的综合优势，<br />
                    有助于提高A股投资决策的质量。<br />
                  </span>
                  <i class="el-icon-question" style="color:#999;font-size:14px" slot="reference"></i>
                </el-popover>
                <br />
              </h3>
            </el-col>
            <el-col :span="10" style="text-align:right">
              <div style="clear:both;height:25px"></div>
              <span style="color:#888;font-size:0.8em">榜单日期:&nbsp;{{ hotStocks.score_date }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-table stripe :data="hotStocks.score" v-loading="!(candidateOptions && candidateOptions.length > 0)">
              <el-table-column label="股票" prop="name"> </el-table-column>

              <el-table-column label="AI评分" prop="score"> </el-table-column>
              <el-table-column label="收盘价(元)" prop="close">
              </el-table-column>

              <el-table-column label="涨跌幅(%)">
                <template slot-scope="scope">
                  <template v-if="scope.row.change > 0">
                    <span style="color:red"> {{ scope.row.change }}%</span>
                  </template>
                  <template v-if="scope.row.change < 0">
                    <span style="color:green"> {{ scope.row.change }}%</span>
                  </template>
                  <template v-if="scope.row.change === 0">
                    <span> {{ scope.row.change }}</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="总市值(亿)" prop="tmv"> </el-table-column>
              <el-table-column label="流通市值(亿)" prop="cmv">
              </el-table-column>
              <el-table-column label="成交量(万手)" prop="tq">
              </el-table-column>
              <el-table-column label="换手率" prop="turnover">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text" size="small">生成报告</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row>
            <el-col :span="14">
              <h3>
                <br />
                财务指标 &nbsp;TOP10
              </h3>
            </el-col>
            <el-col :span="10" style="text-align:right">
              <div style="clear:both;height:25px"></div>
              <br />
              <span style="color:#888;font-size:0.8em">榜单日期:&nbsp;{{ hotStocks.date }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-tabs type="card">
              <el-tab-pane label="ROA">
                <el-row>
                  <el-table stripe :data="hotStocks.roa">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="ROA(%)" prop="roa">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="财务周期" prop="accper">
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="净现比">
                <el-row>
                  <el-table stripe :data="hotStocks.cashratio" v-loading="!(candidateOptions && candidateOptions.length > 0)
    ">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="净现比" prop="cashratio">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="财务周期" prop="accper">
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="净利润增长率">
                <el-row>
                  <el-form>
                    <el-form-item label="排序依据">
                      <template>
                        <el-select v-model="growth_type" :popper-append-to-body="false" placeholder="请选择">
                          <el-option label="同比" value="growth_year">
                          </el-option>
                          <el-option label="环比" value="growth"> </el-option>
                        </el-select>
                      </template>
                    </el-form-item>
                  </el-form>
                </el-row>
                <el-row>
                  <el-table stripe :data="hotStocks[growth_type]">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="净利润增长率(%)" prop="growth">
                      <template slot-scope="scope">
                        {{ scope.row.growth || scope.row.growth_year }}
                      </template>
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="财务周期" prop="accper">
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="流动比率">
                <el-row>
                  <el-table stripe :data="hotStocks.current" v-loading="!(candidateOptions && candidateOptions.length > 0)
    ">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="流动比率" prop="current">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="财务周期" prop="accper">
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-row>
          <el-row>
            <el-col :span="14">
              <h3><br />行情指标&nbsp;TOP10</h3>
            </el-col>
            <el-col :span="10" style="text-align:right">
              <div style="clear:both;height:25px"></div>
              <span style="color:#888;font-size:0.8em"><br />榜单日期:&nbsp;{{ hotStocks.date }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-tabs type="card">
              <el-tab-pane label="全部">
                <el-row>
                  <el-form>
                    <el-form-item label="排序依据">
                      <template>
                        <el-select v-model="list_type" :popper-append-to-body="false" placeholder="请选择">
                          <el-option label="涨幅榜" value="up"> </el-option>
                          <el-option label="跌幅榜" value="down"> </el-option>
                          <el-option label="换手率榜" value="turn"> </el-option>
                          <el-option label="市盈率榜" value="pe"> </el-option>
                        </el-select>
                      </template>
                    </el-form-item>
                  </el-form>
                </el-row>
                <el-row>
                  <el-table stripe v-show="list_type === 'up'" :data="hotStocks.up">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>

                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="list_type === 'down'" :data="hotStocks.down">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>

                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="list_type === 'turn'" :data="hotStocks.turn">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>

                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="list_type === 'pe'" :data="hotStocks.pe">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>

                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="上证A股">
                <el-row>
                  <el-form>
                    <el-form-item label="排序依据">
                      <template>
                        <el-select v-model="main_list" :popper-append-to-body="false" placeholder="请选择">
                          <el-option label="涨幅榜" value="main_up">
                          </el-option>
                          <el-option label="跌幅榜" value="main_down">
                          </el-option>
                          <el-option label="换手率榜" value="main_turn">
                          </el-option>
                          <el-option label="市盈率榜" value="main_pe">
                          </el-option>
                        </el-select>
                      </template>
                    </el-form-item>
                  </el-form>
                </el-row>
                <el-row>
                  <el-table stripe v-show="main_list === 'main_up'" :data="hotStocks.main_up">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="main_list === 'main_down'" :data="hotStocks.main_down">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="main_list === 'main_turn'" :data="hotStocks.main_turn">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>

                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="main_list === 'main_pe'" :data="hotStocks.main_pe">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="深证A股">
                <el-row>
                  <el-form>
                    <el-form-item label="排序依据">
                      <template>
                        <el-select v-model="smb_list" :popper-append-to-body="false" placeholder="请选择">
                          <el-option label="涨幅榜" value="smb_up"> </el-option>
                          <el-option label="跌幅榜" value="smb_down">
                          </el-option>
                          <el-option label="换手率榜" value="smb_turn">
                          </el-option>
                          <el-option label="市盈率榜" value="smb_pe">
                          </el-option>
                        </el-select>
                      </template>
                    </el-form-item>
                  </el-form>
                </el-row>
                <el-row>
                  <el-table stripe v-show="smb_list === 'smb_up'" :data="hotStocks.smb_up">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="smb_list === 'smb_down'" :data="hotStocks.smb_down">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="smb_list === 'smb_turn'" :data="hotStocks.smb_turn">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>

                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="smb_list === 'smb_pe'" :data="hotStocks.smb_pe">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="科创板">
                <el-row>
                  <el-form>
                    <el-form-item label="排序依据">
                      <template>
                        <el-select v-model="star_list" :popper-append-to-body="false" placeholder="请选择">
                          <el-option label="涨幅榜" value="star_up">
                          </el-option>
                          <el-option label="跌幅榜" value="star_down">
                          </el-option>
                          <el-option label="换手率榜" value="star_turn">
                          </el-option>
                          <el-option label="市盈率榜" value="star_pe">
                          </el-option>
                        </el-select>
                      </template>
                    </el-form-item>
                  </el-form>
                </el-row>
                <el-row>
                  <el-table stripe v-show="star_list === 'star_up'" :data="hotStocks.star_up">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="star_list === 'star_down'" :data="hotStocks.star_down">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="star_list === 'star_turn'" :data="hotStocks.star_turn">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>

                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="star_list === 'star_pe'" :data="hotStocks.star_pe">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="创业板">
                <el-row>
                  <el-form>
                    <el-form-item label="排序依据">
                      <template>
                        <el-select v-model="gem_list" :popper-append-to-body="false" placeholder="请选择">
                          <el-option label="涨幅榜" value="gem_up"> </el-option>
                          <el-option label="跌幅榜" value="gem_down">
                          </el-option>
                          <el-option label="换手率榜" value="gem_turn">
                          </el-option>
                          <el-option label="市盈率榜" value="gem_pe">
                          </el-option>
                        </el-select>
                      </template>
                    </el-form-item>
                  </el-form>
                </el-row>
                <el-row>
                  <el-table stripe v-show="gem_list === 'gem_up'" :data="hotStocks.gem_up">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="gem_list === 'gem_down'" :data="hotStocks.gem_down">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>

                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="gem_list === 'gem_turn'" :data="hotStocks.gem_turn">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>

                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table stripe v-show="gem_list === 'gem_pe'" :data="hotStocks.gem_pe">
                    <el-table-column label="股票" prop="name">
                    </el-table-column>
                    <el-table-column label="市盈率" prop="pe">
                    </el-table-column>
                    <el-table-column label="收盘价(元)" prop="close">
                    </el-table-column>

                    <el-table-column label="涨跌幅(%)">
                      <template slot-scope="scope">
                        <template v-if="scope.row.change > 0">
                          <span style="color:red">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change < 0">
                          <span style="color:green">
                            {{ scope.row.change }}%</span>
                        </template>
                        <template v-if="scope.row.change === 0">
                          <span> {{ scope.row.change }}</span>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="总市值(亿)" prop="tmv">
                    </el-table-column>
                    <el-table-column label="流通市值(亿)" prop="cmv">
                    </el-table-column>
                    <el-table-column label="成交量(万手)" prop="tq">
                    </el-table-column>
                    <el-table-column label="换手率" prop="turnover">
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="quickGenPdf(scope.row.stock_code, '涨幅榜')" type="text"
                          size="small">生成报告</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-row>
        </template>
      </el-row>
    </el-row>

    <!--类型选择框-->
    <el-dialog width="600px" :visible.sync="typeDialogVisible">
      <div class="c_p" slot="title">
        <b>{{ stockName || '个股分析' }}</b>
      </div>
      <el-row>
        智能财经报告分析平台已识别到目标公司的以下属性，并将据此自动调整
        <span class="c_p">报告内容</span> <br /><br />
      </el-row>
      <el-row v-if="stockStates === 'PT' || stockStates === 'D' || stockStates === 'WD'
    ">
        <span class="c_p">
          该股票存在数据缺失，可能影响报告效果，请确认是否继续生成？</span>
        <br /><br />
      </el-row>
      <el-row>
        <el-col :span="3">
          所属板块
        </el-col>
        <el-col :span="5">
          <el-tag type="warning"> {{ stockTags.block || '无' }}</el-tag>
          <br />
        </el-col>
        <el-col :span="3">
          上市状态
        </el-col>
        <el-col :span="13">
          <template v-for="(item, index) in stockStates">
            <el-tag type="danger" :key="index">{{
    item.list_status | stockStatusFilter
  }}</el-tag>
          </template>
        </el-col>
        <el-row>
          &nbsp;
        </el-row>
        <el-col :span="3">
          申万行业
        </el-col>
        <el-col :span="5">
          <el-tag> {{ stockTags.industry || '无' }}</el-tag>
        </el-col>
        <el-col :span="3">
          所属概念
        </el-col>
        <el-col :span="13">
          <template v-if="stockTags && stockTags.concepts && stockTags.concepts.length > 0
    ">
            <template v-for="(item, index) in stockTags.concepts">
              <el-tag v-if="index < 3" :key="index" type="success">
                {{ item }}</el-tag>&nbsp;
            </template>
          </template>
          <template v-else>
            <el-tag type="success"> 无</el-tag>
          </template>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-form>
        <el-form-item label="报告类型">
          <template>
            <!-- <el-radio v-model="reportType"
                      label="FULL">个股分析（增强版）</el-radio> -->
            <el-radio v-model="reportType" label="SIMPLE">个股分析报告</el-radio>

            <el-radio v-model="reportType" :disabled="!(
    stockStates &&
    stockStates[0] &&
    stockStates[0].is_normal_template
  )
    " label="TINY">个股分析简报</el-radio>
          </template>
        </el-form-item>

        <el-form-item label="文件类型">
          <template>
            <el-radio v-model="fileType" label="PDF">PDF</el-radio>
            <el-radio v-model="fileType" label="DOC">word</el-radio>
          </template>
        </el-form-item>
        <el-form-item label="选择日期">
          <el-date-picker value-format="yyyy-MM-dd" :picker-options="pickerOptions" v-model="chooseDate" type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <GenDialog />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="typeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="genPdf">生 成</el-button>
      </div>
    </el-dialog>

    <el-dialog width="500" top="0" :close-on-click-modal="false" :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl + '#toolbar=0'" style="width: 100%;height: calc(100vh - 120px);border: 0;" />
      <div style="text-align:center">
        <el-button @click="toDownPdf()" size="small">下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import pay from '../pay'
import moment from 'moment'
export default {
  name: 'stock',
  data: function () {
    let _this = this
    return {
      curStock: {},
      stockCode: '',
      stockName: '',
      searchStock0001: {},
      searchLabel: '搜索结果',
      reportType: 'SIMPLE',
      fileType: 'PDF',
      chooseDate: new Date(),
      options: [],
      candidateOptions: [],
      pdfUrl: '',
      loading: false,
      hotStocks: {
        comment: {}
      },
      growth_type: 'growth_year',
      pdfDialogVisible: false,
      tabsName: 'finance',
      openDate: '',
      openHtml: '',
      closeDate: '',
      closeHtml: '',
      curSourceId: '',
      typeDialogVisible: false,
      selectDialogVisible: false,
      bkCode: {},
      selectForm: {},
      searchLogs: [],
      searchStocks: [],
      reportId: '',
      searchIndustryList: [],
      searchCompanyTypeList: [],
      searchLocationList: [],
      searchConceptList: [],

      list_type: 'up',
      star_list: 'star_up',
      gem_list: 'gem_up',
      smb_list: 'smb_up',
      main_list: 'main_up',
      stockStates: [],
      stockTags: [],
      tradeDates: [],
      pickerOptions: {
        disabledDate (time) {
          let dateStr = moment(time).format('YYYY-MM-DD')
          return _this.tradeDates.indexOf(dateStr) === -1
        }
      }
    }
  },

  components: {
    pay
  },

  watch: {
    payResult: function () {
      this.reportId = this.$store.state.payData.id
      if (this.reportId) {
        this.getReportStatus()
      }
    }
  },

  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    },
    stockStatusFilter: function (v) {
      switch (v) {
        case 'N':
          return '新股'
        case 'SN':
          return '次新股'
        case 'PT':
          return '等待退市'
        case 'D':
          return '退市'
        case 'WD':
          return '退市整理'
        case 'L':
          return '正常'
        default:
          return v
      }
    }
  },
  computed: {
    payResult: function () {
      return this.$store.state.payResult
    },
    userInfo: function () {
      let temp = localStorage.getItem('userinfo')
      if (temp) {
        return JSON.parse(temp)
      }
      return null
    },
    accountinfo: function () {
      let temp = localStorage.getItem('accountinfo')
      if (temp) {
        return JSON.parse(temp)
      }
      return {}
    }
  },
  methods: {
    quickGenPdf (symbol, source) {
      if (source) {
        // eslint-disable-next-line no-undef
        _hmt.push(['_trackEvent', '生成个股报告来源', source])
      }
      this.stockCode = symbol
      this.options = this.candidateOptions
      if (!this.stockCode) {
        this.$message.error('请选择股票')
        return
      }
      if (this.stockCode.indexOf('.') > -1) {
        let tsCodeArray = this.stockCode.split('.')
        this.stockCode = (tsCodeArray[1] + tsCodeArray[0]).toLowerCase()
      }
      let _this = this
      this.candidateOptions.forEach(i => {
        if (i.ts_code.indexOf(symbol) > -1) {
          _this.stockName = i.name
        }
      })

      axios
        .get(
          `/api/web/stock/checkStock/${this.reportType}/${this.stockCode}`
        )
        .then(resp => {
          _this.stockStates = resp.data
        })
      axios.get('/api/web/stock/stockLabel/' + this.stockCode).then(resp => {
        _this.stockTags = resp.data
      })
      axios.get('/api/web/report/tradeDate/' + this.stockCode).then(resp => {
        _this.tradeDates = resp.data
        _this.chooseDate = _this.tradeDates.slice(0)[0]
      })
      this.typeDialogVisible = true
    },

    genPdf () {
      this.typeDialogVisible = false
      let _this = this
      this.loading = true
      axios
        .get(
          `/api/web/report/genReport/${this.fileType}/${this.reportType}/${this.stockCode}?date=${this.chooseDate}`
        )
        .then(resp => {
          _this.pdfUrl = ''
          _this.reportId = resp.data.id
          _this.$store.commit('toFreshUserPrice')
          _this.getReportStatus()
        })
        .catch(e => {
          _this.loading = false
          if (e.code === 401) {
            _this.$alert(e.msg, '您的使用次数已超过限制!')
          }
        })
    },

    getReportStatus () {
      let _this = this
      axios.get('/api/web/stock/reportInfo/' + _this.reportId).then(resp => {
        _this.loading = true
        if (resp.data.status === 'DOING') {
          _this.loading = true
          setTimeout(() => {
            _this.getReportStatus(_this.reportId)
          }, 2000)
        } else if (resp.data.status === 'FINISH') {
          _this.loading = false
          _this.sourceId = resp.data.sourceId
          if (resp.data.fileType === 'PDF') {
            _this.pdfDialogVisible = true
            _this.pdfUrl = '/api/web/stock/readPdf/' + this.sourceId
            _this.pdfDialogVisible = true
          } else {
            _this.toDownPdf()
          }
        } else {
          _this.loading = false
          _this.$notify.error({
            title: '失败',
            message: '报告生成失败，请稍候重试。'
          })
        }
      })
    },

    showSearchLogs () {
      this.searchLabel = '搜索历史'
      this.options = this.searchLogs
    },
    searchStock (query) {
      this.searchLabel = '搜索结果'
      query = query.trim()
      if (query) {
        let _this = this
        setTimeout(() => {
          _this.options = _this.candidateOptions.filter(item => {
            return (
              item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.ts_code.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              (item.pinyin || '').toLowerCase().indexOf(query.toLowerCase()) >
              -1
            )
          })
        }, 200)
      } else {
        this.options = this.searchLogs
      }
    },
    searchCompareStock (query) {
      query = query.trim()
      if (query !== '') {
        let _this = this
        setTimeout(() => {
          _this.compareOptions = _this.candidateOptions.filter(item => {
            return (
              item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.ts_code.toLowerCase().indexOf(query.toLowerCase()) > -1
            )
          })
        }, 200)
      } else {
        this.compareOptions = this.searchLogs
      }
    },

    toDownPdf () {
      window.open('/api/web/stock/downLoadReport/' + this.sourceId)
    },

    getSearchLogs (item) {
      this.searchLabel = '搜索历史'
      let url = '/api/web/stock/searchLogs'
      if (item) {
        url = url + '?code=' + item
      }
      let _this = this
      axios.get(url).then(resp => {
        _this.searchLogs = resp.data
      })
    },
    searchStockBySelect (p) {
      this.selectForm.page = p
      let _this = this
      if (
        !this.selectForm.location &&
        !this.selectForm.companyType &&
        !this.selectForm.concept &&
        !this.selectForm.industry
      ) {
        _this.searchStocks = []
        _this.selectForm.total = 0
        return
      }
      axios
        .post('/api/web/stock/stockSearchList', this.selectForm)
        .then(resp => {
          _this.searchStocks = resp.data.records
          _this.selectForm.total = parseInt(resp.data.total)
        })
    }
  },

  mounted () {
    let _this = this
    try {
      this.candidateOptions = JSON.parse(
        localStorage.getItem('candidateOptions')
      )
      this.hotStocks = JSON.parse(localStorage.getItem('hotStocks'))

      this.conceptUpDlowList = localStorage.getItem('conceptUpDlowList')
    } catch (e) { }
    axios.get('/api/web/stock/list').then(resp => {
      _this.candidateOptions = resp.data
      localStorage.setItem(
        'candidateOptions',
        JSON.stringify(_this.candidateOptions)
      )
      _this.loading = false
    })

    axios.get('/api/web/stock/upDownList?count=' + 6).then(resp => {
      _this.hotStocks = resp.data
      localStorage.setItem('hotStocks', JSON.stringify(_this.hotStocks))
    })

    this.getSearchLogs()

    axios.get('/api/web/stock/industryList').then(resp => {
      _this.searchIndustryList =
        resp.data &&
        JSON.parse(resp.data) &&
        JSON.parse(resp.data).data &&
        JSON.parse(resp.data).data.industrySearch &&
        JSON.parse(JSON.parse(resp.data).data.industrySearch.result)
    })

    axios.get('/api/web/stock/companyTypeList').then(resp => {
      _this.searchCompanyTypeList =
        resp.data &&
        JSON.parse(resp.data) &&
        JSON.parse(resp.data).data &&
        JSON.parse(resp.data).data.natureSearch &&
        JSON.parse(JSON.parse(resp.data).data.natureSearch.result)
    })

    axios.get('/api/web/stock/locationList').then(resp => {
      _this.searchLocationList =
        resp.data &&
        JSON.parse(resp.data) &&
        JSON.parse(resp.data).data &&
        JSON.parse(resp.data).data.locationSearch &&
        JSON.parse(JSON.parse(resp.data).data.locationSearch.result)
    })

    axios.get('/api/web/stock/conceptList').then(resp => {
      _this.searchConceptList =
        resp.data &&
        JSON.parse(resp.data) &&
        JSON.parse(resp.data).data &&
        JSON.parse(resp.data).data.conceptSearch &&
        JSON.parse(JSON.parse(resp.data).data.conceptSearch.result)
    })
  }
}
</script>
<style lang="less" scoped>
.openCloseIframe {
  border: 0px;
  width: 603px;
  height: calc(100vh - 203px);
}

.container-fluid {
  background: url('/static/img/courses-header.jpg');
  height: 400px;
}

.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}

.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/stock.vue